<template>
  <div class="aw-iot-solution">
    <div class="com-sub-top">
      <div class="title container-center">物联网+解决方案</div>
    </div>
    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">海云捷迅物联网+解决方案</p>
        <p class="desc">
          海云捷迅的物联网解决方案涵盖了从芯片、网络、云平台到行业应用的全栈式服务。通过连接物理世界和数字世界，推动各行各业的数字化转型。海云捷迅能够提供全面的技术支持和服务，包括项目咨询、方案设计、系统集成、运维服务等，帮助客户实现物联网项目的成功落地。
        </p>
      </div>
    </div>

    <div class="com-desc-box iot-sol-bg iot-sol-bg1">
      <div class="container-center com-center advantage">
        <p class="title">5G全连接解决方案</p>
        <p class="desc">
            ·为垂直行业客户提供专属网络覆盖、专用网络资源和专有网络服务，技术基于开源内核，遵循3GPP协议，采用基于内核模块机制的硬件极简架构和SDN设计思想，以及微服务架构。旨在为企业提供高效、经济的5G网络部署。<br/><br/>
            ·该平台可广泛应用于5G+智慧场桥，5G+智慧工厂，AGV小车送件，智能仓储，MES系统，5G+移动式监控球，5G+车路协同。为不同行业的物联网应用提供了统一的数据管理平台。
        </p>
      </div>
    </div>

    <div class="com-desc-box iot-sol-bg iot-sol-bg2">
      <div class="container-center com-center advantage">
        <p class="title">工业物联网解决方案</p>
        <p class="desc">
            ·通过对生产过程中的数据进行采集和分析，优化生产流程，提高生产效率和产品质量。例如，在金属加工行业中，根据对零件表层的采样数据的分析，调整生产参数，提高产品品质。
        </p>
      </div>
    </div>

    <div class="com-desc-box iot-sol-bg iot-sol-bg3">
      <div class="container-center com-center advantage">
        <p class="title">智慧校园解决方案</p>
        <p class="desc">
            ·海云捷迅智慧校园解决方案是指以促进信息技术与教育教学融合、提高学与教的效果为目的，以物联网、云计算、大数据分析等新技术为核心技术，提供一种环境全面感知、智慧型、数据化、网络化、协作型一体化的教学、科研、管理和生活服务，并能对教育教学、教育管理进行洞察和预测的智慧学习环境。<br/><br/>
            ·海云捷迅智慧校园解决方案覆盖了上级单位、学校领导、教师、学生、校辅人员、信息中心及IT运维人员的全方位需求，从招生到迎新，从学工到离校就业，提供了全面的智慧校园服务。
        </p>
      </div>
    </div>

    <div class="com-desc-box iot-sol-bg iot-sol-bg4">
      <div class="container-center com-center advantage">
        <p class="title">智慧农业解决方案</p>
        <p class="desc">
            ·利用传感器等设备实时采集农业生产环境中的温度、湿度、光照等数据，并通过物联网技术将这些数据传输到管理平台。让用户及时了解力棚内环境的变化趋势、农作物健康状况和大棚安全情况，实现对农业生产环境的精准调控，提高农作物的产量和质量。
        </p>
      </div>
    </div>

    <div class="com-desc-box iot-sol-bg iot-sol-bg5">
      <div class="container-center com-center advantage">
        <p class="title">消防联网解决方案</p>
        <p class="desc">
            ·传统的消防：系统往往存在信息孤岛、响应速度慢、资源配置不合理等问题。为了提高消防应急响应效率和安全管理水平，海云捷迅推出了消防联网解决方案，旨在通过先进的信息技术实现消防资源的优化配置和高效管理。
        </p>
      </div>
    </div>

    <div class="com-desc-box iot-sol-bg iot-sol-bg6">
      <div class="container-center com-center advantage">
        <p class="title">智慧社区解决方案</p>
        <p class="desc">
            ·通过物联网技术将社区内的各种智能设备，如门禁系统、监控摄像头、智能充电桩、智能垃圾桶等连接起来，实现设备的集中管理和控制。例如，居民可以通过手机 APP 远程控制门禁的开关，物业管理人员可以实时监控社区内设备的运行状态。
        </p>
      </div>
    </div>
 
  </div>
</template>
<script>
export default {
    data() {
        return {
            key: "1"
        }
    },
    methods: {
        choose(val) {
            this.key = val;
        },
    }
}
</script>